import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  PersonAttributeAudit,
  PersonAttributeSkeleton
} from '../../+models/person-profile-audit.model';

@Component({
  selector: 'sd-portal-person-profile-attribute-audit-list',
  templateUrl: './person-profile-attribute-audit-list.component.html',
  styleUrls: ['./person-profile-attribute-audit-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PersonProfileAttributeAuditListComponent implements OnInit {
  @Input() personAttribute: PersonAttributeSkeleton;
  @Input() loading: boolean;
  @Input() personAttributeAudits: PersonAttributeAudit[];

  @Output() loadPersonAttributeAudits: EventEmitter<number> = new EventEmitter<number>();
  @Output() nextPage: EventEmitter<number> = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  loadData() {
    this.loadPersonAttributeAudits.emit(this.personAttribute.personAttributeId);
  }

  onNextPage() {
    this.nextPage.emit(this.personAttribute.personAttributeId);
  }
}
